import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import ResponsiveFooter from "../components/Reaponsivefooter";
import BackgroundLottie from "../components/BackgroundLottie";
import { Outlet, useLocation } from "react-router-dom";
import ToastContainer from "../components/Toastcontainer";
import "../App.css";

const MainLayout = () => {
  const location = useLocation();

 
 


  return (
    <>
      <ToastContainer />
      <BackgroundLottie />
      <Header />

      <main className="main-layout-content">
        <Outlet />
      </main>

     
      <Footer />
      <ResponsiveFooter />
    </>
  );
};

export default MainLayout;
